"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useHasSortingColumns = function (columns) {
    var hasSortingColumns = (0, react_1.useMemo)(function () { return columns.some(function (_a) {
        var _b = _a.isSorting, isSorting = _b === void 0 ? false : _b;
        return isSorting;
    }); }, [columns]);
    return hasSortingColumns;
};
exports.default = useHasSortingColumns;
